var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-section"},[_c('button',{staticClass:"sk-link contract-section__link",on:{"click":_vm.decriptFile}},[_vm._v(_vm._s(_vm.linkText))])])}
var staticRenderFns = []

export { render, staticRenderFns }